export default "__VITE_ASSET__pIsbb2xt__"